export default __webpack_public_path__ + "static/media/gallery-wip-neck-rib_01.1fd3e777.jpg";